import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import HowItWorks from '../components/HowItWorks';
import ThemeCollections from '../components/ThemeCollections';
import Footer from '../components/Footer';
import ThemeModal from '../components/ThemeModal';

const Home = () => {
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleThemeClick = (theme) => {
    setSelectedTheme(theme);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedTheme(null), 300);
  };

  return (
    <div className="home-container">
      <Header />
      <Hero />
      <About />
      <HowItWorks />
      <ThemeCollections onThemeClick={handleThemeClick} />
      <Footer />
      
      {selectedTheme && (
        <ThemeModal 
          theme={selectedTheme} 
          isOpen={isModalOpen} 
          onClose={handleCloseModal} 
        />
      )}
    </div>
  );
};

export default Home;
